<template>
  <div id="dashboard-page">
    <vs-tabs v-if="renderCoverHolderHomepage">
      <vs-tab label="Producer Report">
        <div class="vx-card full-page">
          <producer-report/>
        </div>
      </vs-tab>
      <vs-tab label="Coverholder Report">
        <div class="vx-card">
          <coverholder-report/>
        </div>
      </vs-tab>
    </vs-tabs>

    <producer-report v-else/>
  </div>
</template>

<script>
  import ProducerReport from "@/views/pages/Dashboard/ProducerReport";
  import CoverholderReport from "@/views/pages/Dashboard/CoverholderReport";
  import store from '@/store/store';


  export default {
    components: {
      ProducerReport,
      CoverholderReport,
    },
    data() {
      return {
        renderCoverHolderHomepage: false,
        retriedCoverHolderHomepagePrivilege: false,
      };
    },
    computed: {
    },
    methods: {
      checkCoverHolderHomepagePrivilege() {
        let privilegesData = store.getters['personas/privileges'];
        
        if (!privilegesData || privilegesData.length === 0) {
          // Only retry once
          if (!this.retriedCoverHolderHomepagePrivilege) {
            this.retriedCoverHolderHomepagePrivilege = true;
            
            setTimeout(() => {
              this.checkCoverHolderHomepagePrivilege();
            }, 1000);
          }

          return;
        }

        const coverHolderHomepage = privilegesData.find((navAccessItem) => navAccessItem.PageName === 'coverholder_dashboard');

        if (!coverHolderHomepage) {
          return false;
        }
        
        this.renderCoverHolderHomepage = coverHolderHomepage.View;

        return this.renderCoverHolderHomepage;
      },
    },
    created() {
      this.checkCoverHolderHomepagePrivilege();
    },
  };
</script>

<style lang="scss">
  @import '@/assets/scss/custom/components/variables';

  #dashboard-page {
    .main-grid >.con-vs-card,
    .side-charts {
      @media (min-width: $xl) {
        height: calc(var(--vh, 1vh) * 100 - 21rem) !important;
        min-height: 640px;
        // max-height: 657px;
      }
    }

    .ag-header-cell-menu-button {
      display: none;
    }

    .vs-card--content {
      margin: 0;
      width: 100%;
      overflow: hidden;
    }

    .charts-row {
      .vs-card--content {
        padding: 0.1px;
      }
    }

    .con-vs-card {
      height: 100%;
      color: #212529;

      .vs-card--header {
        box-shadow: none;
      }

      .vs-card--content {
        .vx-col {
          .header-card-title {
            color: #53565B;
            font-size: 13px;
          }
          
          .header-card-value {
            font-size: 18px;
            min-height: 21px;

            @media (max-width: $md) {
              font-size: 15px;
            }
          }
        }
      }
    }

    .header-cards {
      > .vx-col {
        .header-card-icon {
          shape-rendering:crispEdges;
          font-size: 15px;
        }

        @media (min-width: $lg) {
          &:first-child {
            padding-right: 0.5rem;
          }

          &:last-child {
            padding-left: 0.5rem;
          }
        }

        .vs-card--content {
          padding: 0.1px;
          margin: -10px 0;

          .vx-row {
            padding: 10px 0;
            margin: 0;

            .vx-col {
              border-top: 1px solid #D5DAE0;
              padding-block: 15px;

              &:not(:last-child) {
                border-right: 1px solid #D5DAE0;
                padding-right: 0;
              }
            
              .header-card-title {
                line-height: 15px;
                margin-bottom: 5px;
              }
            
              .header-card-value {
                line-height: 21px;
              }
            }
          }
        }
      }
    }

    .side-charts {
      @media (min-width: $xl) {
        padding-left: 0.5rem;
      }

      .vx-row {
        height: 100%;

        .pie-chart,
        .bar-chart {
          height: 276px;

          @media (min-width: $xl) {
            height: 50%;
            min-height: unset;
          } 
        }

        .bar-chart {
          @media (max-width:$xl) {
            padding-top: 1rem;
            padding-right: 0.5rem;
          }

          .apexcharts-legend {
            display: none;
          }

          .vs-card--content {
            height: 100%;
          }
        }

        .pie-chart {
          padding-top: 1rem;

          // Pie Chart 1
          &:nth-child(2) {
            @media (min-width:$md) {
              padding-right: 0.5rem;
            }
            
            @media (min-width:$md) and (max-width:$lg) {
              padding-left: 0.5rem;
            }
          }

          // Pie Chart 2
          &:nth-child(3) {
            padding-left: 0.5rem;
          }

          .con-vs-card {
            display: flex;
            justify-content: center;
            padding-block: 1rem;
          }

          .vs-card--content {
            > div {
              // max-width: 255px;
              margin-inline: auto;
            }
          }
        }
      }
    }

    .main-grid {
      @media (min-width: $xl) {
        padding-right: 0.5rem;
      }

      > .con-vs-card,
      .ag-theme-material.ag-grid-table {
        @media (min-width: $md) {
          height: calc(var(--vh, 1vh) * 100 - 60rem);
        }

        @media (min-width:$md) and (max-width:$lg) {
          min-height: 300px;
        }

        @media (min-width: $md) {
          height: calc(var(--vh, 1vh) * 100 - 30rem);
        }

        // @media (min-width: $lg) {
        //   height: calc(var(--vh, 1vh) * 100 - 5rem);
        // }

        height: calc(var(--vh, 1vh) * 100 - 30rem);
        min-height: 635px;
        // max-height: initial;
      }

      .dashboard-grid {
        border: none;
        padding: 0;
        margin: 0;

        .ag-row {
          background-color: white !important;

          &.ag-row-level-0 {
            background-color: #e7e6e6  !important;
          }
        }

        .ag-theme-material.ag-grid-table {
          border: none;
          margin: 0;
          padding: 0;
        }

        .ag-root-wrapper {
          border-radius: 8px;
        }
      }
    }
  }
</style>

